import { render, staticRenderFns } from "./Edit_Renew.vue?vue&type=template&id=61228a7b&scoped=true&"
import script from "./Edit_Renew.vue?vue&type=script&lang=js&"
export * from "./Edit_Renew.vue?vue&type=script&lang=js&"
import style0 from "./Edit_Renew.vue?vue&type=style&index=0&id=61228a7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61228a7b",
  null
  
)

export default component.exports